<template>
  <aha-modal :title="category.value" @hide="$emit('hide')" size="3xl">
    <section class="correct-options">
      <div v-for="(option, index) in category.options" :key="index" class="option">
        {{ option.value }}
      </div>
    </section>
  </aha-modal>
</template>

<script>

export default {
  props: {
    category: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    // categoryColorMap: {
    //   type: Array,
    //   required: true,
    //   default: () => [],
    // },
    // categoryBackgroundColorMap: {
    //   type: Array,
    //   required: true,
    //   default: () => [],
    // },
    // categoryAnnotationMap: {
    //   type: Array,
    //   required: true,
    //   default: () => [],
    // },
  },
}

</script>

<style lang="scss" scoped>
    .correct-options {
        height: 293px;
        max-height: 293px;
        overflow-y: auto;
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        grid-template-rows: min-content;
        gap: 0.75rem;

        & > .option {
            padding: 0.75rem;
            border-radius: 0.5rem;
            border: 1px solid #D3D7E1;
        }
    }
</style>
